module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "mt-border col-sm-12",
    staticStyle: {
      "padding": "15px",
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "md-headline",
    staticStyle: {
      "color": "#4d5667",
      "margin-top": "30px",
      "font-weight": "500",
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.diary.delete.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errorsPatient.hasOwnProperty('code')
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.diary.delete.fields.code))]), _vm._v(" "), _c('md-input', {
    on: {
      "change": function($event) {
        _vm.changeCodePatient()
      }
    },
    model: {
      value: (_vm.patient.code),
      callback: function($$v) {
        _vm.patient.code = $$v
      },
      expression: "patient.code"
    }
  }), _vm._v(" "), (_vm.errorsPatient.code) ? _c('span', {
    class: ['md-error', {
      'code_active': _vm.data.activeCode === 1
    }]
  }, [_vm._v(_vm._s(_vm.errorsPatient.code))]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "multiple"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.translate.pages.diary.delete.fields.appointments))]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, _vm._l((_vm.data.listcitas), function(cita) {
    return _c('md-checkbox', {
      key: cita.id,
      staticClass: "option",
      on: {
        "change": function($event) {
          _vm.onChosen($event, cita.id)
        }
      },
      model: {
        value: (cita.checked),
        callback: function($$v) {
          cita.checked = $$v
        },
        expression: "cita.checked"
      }
    }, [_vm._v(_vm._s(cita.title) + ": " + _vm._s(cita.data.fecha) + " - " + _vm._s(cita.hour))])
  })), _vm._v(" "), (_vm.errors.cita) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.cita))]) : _vm._e()])]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent pull-right btn--red md-size",
    nativeOn: {
      "click": function($event) {
        _vm.deleteAgenda($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.actions.delete) + " "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67cc20d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Agenda/Delete.vue
// module id = 696
// module chunks = 1